import { clientProofMessage } from './clientProof';

/**
 * Normalize an Axios error into a string safe to store in React state and render.
 *
 * The backend sometimes returns a structured `detail` OBJECT (e.g. the phone-
 * collision 409s from /register: `{code, phone_masked}`). Rendering that object
 * as a React child crashes the page (React error #31). This maps the known
 * shapes to friendly strings and defensively stringifies anything unexpected.
 *
 * @param {*} err       Axios error (or anything).
 * @param {string} fallback  Message when no usable detail is present.
 * @returns {string}
 */
export function registrationErrorMessage(err, fallback = 'Registration failed') {
  const proofMessage = clientProofMessage(err);
  if (proofMessage) return proofMessage;

  const detail = err?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (detail && typeof detail === 'object') {
    const phone = detail.phone_masked;
    switch (detail.code) {
      case 'existing_account_sign_in':
        return phone
          ? `An account already exists for the phone number ${phone}. Please sign in instead.`
          : 'An account already exists for that phone number. Please sign in instead.';
      case 'existing_account_resent_invite':
        return phone
          ? `You already have an account for the phone number ${phone}. We've re-sent your invite — check your email.`
          : "You already have an account for that phone number. We've re-sent your invite — check your email.";
      case 'phone_required':
        return detail.message || 'Phone number is required.';
      default:
        // Unknown object shape — never return the object itself.
        return typeof detail.message === 'string' && detail.message.trim()
          ? detail.message
          : fallback;
    }
  }

  return fallback;
}
